import React, { useState } from "react";
import "./update.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const UpdateCotation = (props: Props) => {
  const [role, setRole] = useState("");

  const handleChange = (event) => {
    setRole(event.target.value);
  };
  return (
    <div className="UpdateCotation">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Modification</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          <div className="item">
            <label>{"Cotation(ponctualité)"}</label>
            <input
              placeholder="Ex: Retard"
              type="text"
              name="schoolYear"
              // value={data.nom_Nom}
            />
          </div>
          <div className="item">
            <label>Hote</label>
            <div className="role-selector">
              <select
                value={role}
                onChange={handleChange}
                className="input-field"
                name="role"
              >
                <option value="">--Selectionner un hôte--</option>
                <option value="teacher">Enseignant</option>
                <option value="student">Elève</option>
              </select>
            </div>
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          <button>Mettre à jour</button>
        </div>
      </div>
    </div>
  );
};

export default UpdateCotation;
